<div class="atn-ds-search">
  <i class="atn-icon atn-search atn-blue"></i>
  <div class="atn-ds-search__input-text">
    <atn-ds-text
      [disabled]="disabledSg()"
      [placeholder]="placeholderSg()"
      [hasBorder]="false"
      [value]="valueSg()"
      (change)="onValueChangeHandler($event)"
    />
  </div>
</div>
